'use strict';

var React = require('react');

var SvgMinusMinor = function SvgMinusMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 10a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z"
  }));
};
SvgMinusMinor.displayName = "MinusMinor";

exports.SvgMinusMinor = SvgMinusMinor;
